import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import PoserBarChart from "../amcharts/PoserBarChart";
import PoserPieChart from '../amcharts/PoserPieChart';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};


let x_axis = ["instance_name"]; let y_axis = ["Bank Errors","Config Errors"];
let pie_x_axis = ["Instance Name"]; let pie_y_axis = ["Error Percentage"];
let chartHeight= "300px";
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function MergeGridCells() {
    var dimension_cells = new Array();
    var dimension_col = null;
    var columnCount = $("#PoserAggr tr:first th").length;
    //alert(columnCount)
    for (dimension_col = 0; dimension_col <= 1; dimension_col++) {
        // first_instance holds the first instance of identical td
        var first_instance = null;
        var rowspan = 1;
        // iterate through rows
        $("#PoserAggr").find('tr').each(function () {
            //console.log("sssssss");

            // find the td of the correct column (determined by the dimension_col set above)
            var dimension_td = $(this).find('td:nth-child(' + dimension_col + ')');



            if (first_instance === null) {
                // must be the first row
                first_instance = dimension_td;
            } else if (dimension_td.text() === first_instance.text()) {
                // the current td is identical to the previous
                // remove the current td
                // dimension_td.remove();
                dimension_td.attr('hidden', true);
                ++rowspan;
                // increment the rowspan attribute of the first instance
                first_instance.attr('rowspan', rowspan);
            } else {
                // this cell is different from the last
                first_instance = dimension_td;
                rowspan = 1;
            }
        });
    }
}
class PoserReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:true,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tableHeaders:[],
            tableBody:[],
            num_of_column:[],
            isChange:false,
            tenderModeLists:[],
            tenderModeIDs:'',
            tenderModeValue:'',
            txnTypeLists: [],
            txnTypeIDs: "",
            txnTypeValue: "",
            merchantList:[],
            merchantID:'',
            merchantValue:null,
            is_record: true,
            is_exp_button: false,
            ErrGrpLists:[{value:'Bank Errors', label: 'Bank Errors'},{value:'Config Errors', label: 'Config Errors'}],
            ErrGrpValue:'',
            error_group:'',
            tableChart:[],
            pieChartData:[],
            barChartData:[],
            is_bar:false,
            is_pie:false,
            y_axis: ["Bank Errors","Config Errors"],
            fetch_data:false
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });
        this._getAllMerchants();
        this._getTenderMode();
        this._getTxnType();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            //this.get_filtered_poser_report();
            // this.get_filtered_poser_report_row();
            // this.get_poser_details_report();
            this.get_poser_dashboard();
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            var merchantData = [{"value":decoded.object_code, "label":""}]
            //this.changeMerchant(merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(decoded.object_code, 'chain', decoded.object_type, decoded.object_code);
            var chainData = [{"value":decoded.object_code, "label":""}]
            //this.changeChain(chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Store') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            //this.changeStore(storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
            this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }

        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'poser_report','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("poser_report")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }
    _getTenderMode(){
        axios.get(config.get('API_URL')+'/summaryReport/tender-mode/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((tender, index) => {
                    mList.push({value: tender.tender_mode, label: tender.tender_mode})
                });
                this.setState({
                    tenderModeLists:mList,

                })
            }
        });
    }
    _getTxnType(){
        axios.get(config.get('API_URL')+'/summaryReport/txn-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((txn, index) => {
                    mList.push({value: txn.txn_type, label: txn.txn_type})
                });
                this.setState({
                    txnTypeLists:mList,

                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });

        }


        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            isChange: true,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,

        });

    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.setState({
                isChange:true
            })
        }
    }
    get_all_poser_report(){
        this.get_poser_details_report();
        this.get_filtered_poser_report_row();
        this.get_poser_dashboard();
    }
    get_filtered_poser_report_row() {
        this.setState({
            loading:true,
            is_record: true,
            is_exp_button: false
        })
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        axios.post(config.get('API_URL') + '/summaryReport/poser-aggregate-row', {
                mids: this.state.merchantID,
                tender_mode: this.state.tenderModeIDs,
                transaction_type: this.state.txnTypeIDs,
                start_date: this.state.yestSend,
                end_date: this.state.todSend,
                error_group: this.state.error_group
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => { //console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';
                // tableHeaders.push({
                //     sTitle: "" ,
                //     mData: "id"
                //
                // });
                // tableBody.push({
                //     data: "id",
                // });

                keys.forEach(function (k) {
                    if(k=='id' || k=='latestversion') {
                        keyVal = '';
                    }
                    else{
                        keyVal = k;
                    }
                    tableHeaders.push({
                        sTitle: keyVal,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    });
                    headerList.push(k);
                });
                // console.log(JSON.stringify(tableHeaders));
                // console.log(JSON.stringify(tableBody));
                this.setState({
                    loading: false,
                    is_record: true,
                    is_exp_button: true
                });
                this.get_filtered_poser_report(tableHeaders, tableBody,headerList);
            }else {
                if ($.fn.DataTable.isDataTable('#PoserAggr')) {
                    $('#PoserAggr').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                    is_exp_button: false
                });
            }
        });
    }
    get_filtered_poser_report(tableHeaders, tableBody,headerList){


        if ($.fn.DataTable.isDataTable('#PoserAggr')) {
            $('#PoserAggr').DataTable().clear().destroy();
        }
        //this.get_poser_details_report();
        let that = this;
        //disabledBody();
        let postdatatd2 = {
            mids: this.state.merchantID,
            tender_mode: this.state.tenderModeIDs,
            transaction_type: this.state.txnTypeIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            error_group: this.state.error_group
        };
        //alert(idIndex);
        if ($.fn.DataTable.isDataTable('#PoserAggr')) {
            $('#PoserAggr').DataTable().clear().destroy();
        }
        $('#PoserAggr').html('');
        var merchantDataTable1 = $('#PoserAggr').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/poser-aggregate",
                    type: 'POST',
                    data: postdatatd2,
                    dataSrc:function ( json ) { //console.log(json);
                        enabledBody()
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns:tableHeaders,
                columns: tableBody,

            });
    }
    get_poser_details_reports(){
        setTimeout(function(){
            this.get_poser_details_report()
        }.bind(this), 100);
    }
    get_poser_details_report(){
        var that = this;
        //disabledBody()

        var postData = {
            mids: this.state.merchantID,
            tender_mode: this.state.tenderModeIDs,
            transaction_type: this.state.txnTypeIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            error_group: this.state.error_group
        };
        if ($.fn.DataTable.isDataTable('#PoserDetailsTable')) {
            $('#PoserDetailsTable').DataTable().clear().destroy();
        }
        var PoserDetailsTable = $('#PoserDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/poser-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Error Group"},
                    {"data":"Instance"},
                    {"data":"Merchant"},
                    {"data":"Chain"},
                    {"data":"Store"},
                    {"data":"PRIM id"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Utid"},
                    {"data":"Btid"},
                    {"data":"Txn Amount"},
                    {"data":"Masked Card Number"},
                    {"data":"BIN"},
                    {"data":"EMI Bank Code"},
                    {"data":"Acquiring Bank"},
                    {"data":"Issuer Bank"},
                    {"data":"Scheme"},
                    {"data":"Grade"},
                    {"data":"Communication Id"},
                    {"data":"Tender Mode"},
                    {"data":"Credit/Debit"},
                    {"data":"Transaction Type"},
                    {"data":"Approval Code"},
                    {"data":"RRN No"},
                    {"data":"UPI Txn ID"},
                    {"data":"Batch srl"},
                    {"data":"Merchant Invoice Number"},
                    {"data":"Processing Code"},
                    {"data":"Is DCC Transaction"},
                    {"data":"Is International Card"},
                    {"data":"Software Version"},
                    {"data":"Terminal Serial Number"},
                    {"data":"Addional Info1"},
                    {"data":"Addional Info2"},
                    {"data":"CI Inno Response Code"},
                    {"data":"BI Bank Response Code"},
                    {"data":"BO Bank Response Code"},
                    {"data":"CO Inno Response Code"},
                    {"data":"CO Reason Code"},
                    {"data":"CO Reason Message"},
                    {"data":"UFE Message"},

                ],
                // "columnDefs": [
                //     {  render: function (data) {
                //             return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                //         },
                //         "width": "80px",
                //         "targets": 5
                //     },
                //
                // ],

            });
    }
    get_poser_dashboard(){
        let dashboard_component = '';
        for(let i=0; i<=2; i++){
            if(i==0){ dashboard_component='table1'}
            if(i==1){ dashboard_component='pie_chart1'}
            if(i==2){ dashboard_component='bar_graph1'}
            this.get_poser_dashboards(dashboard_component)
        }

    }
    get_poser_dashboards(dashboard_component) {
        if ($.fn.DataTable.isDataTable('#tableChart')) {
            $('#tableChart').DataTable().clear().destroy();
            $('#tableChart').html('');
        }
        if(this.state.error_group==''){
            this.setState({
                y_axis:["Bank Errors","Config Errors"]
            })
        }else {
            this.setState({
                y_axis:this.state.error_group
            })
        }
        let that =this;
        that.setState({
            tableChart: [],
            pieChartData:[],
            barChartData:[],
            is_pie:false,
            is_bar:false
        })
        $('.dataTables_processing', $('#tableChart').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
        axios.post(config.get('API_URL') + '/summaryReport/poser-dashboard', {
                mids: that.state.merchantID,
                tender_mode: that.state.tenderModeIDs,
                transaction_type: that.state.txnTypeIDs,
                start_date: that.state.yestSend,
                end_date: that.state.todSend,
                error_group: that.state.error_group,
                dashboard_component: dashboard_component,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

                if(response.data.dashboard_component=='table1'){
                    if ($.fn.DataTable.isDataTable('#tableChart')) {
                        $('#tableChart').DataTable().clear().destroy();
                        $('#tableChart').html('');
                    }
                    that.setState({
                        tableChart: response.data.data,
                    })
                    const tableHeaders = [];
                    if(response.data.data.length>0){
                        const exampleRecord = response.data.data[0];
                        const keys = Object.keys(exampleRecord);
                        //log(keys);
                        keys.forEach(function(k) {
                            tableHeaders.push({
                                sTitle: k,
                                mData: k.replace(/\./g,'\\.')
                                //optionally do some type detection here for render function
                            });
                        });
                        //console.log(tableHeaders);
                    }


                    $('#tableChart').DataTable({
                        searching: false,
                        bInfo : false,
                        paging: false,
                        "aaSorting": [],
                        bProcessing: true,
                        "aaData": response.data.data,
                        "aoColumns": tableHeaders,


                    });
                }
            if(response.data.dashboard_component=='pie_chart1'){
                if(Array.isArray(response.data.data) && response.data.data.length) {
                    that.setState({
                        pieChartData:response.data.data,
                        is_pie:true
                    })
                }
            }
            if(response.data.dashboard_component=='bar_graph1'){
                if(Array.isArray(response.data.data) && response.data.data.length) {
                    that.setState({
                        barChartData: response.data.data,
                        is_bar:true
                    })
                }
            }
            $('.dataTables_processing', $('#tableChart').closest('.dataTables_wrapper')).hide();


        });
        }, 100);

    }
    poser_report_download (type, e){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            mids: this.state.merchantID,
            tender_mode: this.state.tenderModeIDs,
            transaction_type: this.state.txnTypeIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            type:type,
            error_group: this.state.error_group,
            download: 1
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/summaryReport/poser-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyPoserFile(response.data,type);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyPoserFile (remotePath, type){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = timestamp+type+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }

    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            isChange:true,
            merchantID:'',
            merchantValue:[],
            txnTypeIDs: '',
            txnTypeValue: [],
            tenderModeIDs:'',
            tenderModeValue:[],
            ErrGrpValue:[],
            error_group:'',
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    changeTenderMode(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.tenderModeLists.findIndex(obj => obj.value==ids.value);
                this.state.tenderModeLists.move(index,0).join(',');
            });
        }

        this.setState({
            tenderModeIDs:tenderArray,
            tenderModeValue:optionSelected,
            isChange: true
        });
        //this._get_filtered_eod_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, tenderArray, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs, this.state.is_fallback);

    }
    changeTxnType(optionSelected){
        let value='';
        let txnArray = [];
        if (optionSelected.length < 1) {
            value = null;
            txnArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)
                // var index = this.state.txnTypeLists.findIndex(obj => obj.value==mids.value);
                // this.state.txnTypeLists.move(index,0).join(',');
            });
        }
        if(txnArray.includes("FAILED")===true) {
            txnArray = ['FAILED'];
            optionSelected = [{value: "FAILED", label: "FAILED"}];
        }

        this.setState({
            txnTypeIDs:txnArray,
            txnTypeValue:optionSelected,
            isChange: true
        });
        //this._get_filtered_eod_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, txnArray, this.state.ciutidIds, this.state.isSettledIDs, this.state.is_fallback);
    }
    changeErrGrp(optionSelected){
        let value='';
        let errArray = [];
        if(optionSelected.length < 1){
            value = null;
            errArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                errArray.push(ids.value)

            });
        }

        this.setState({
            error_group:errArray,
            ErrGrpValue:optionSelected,
            isChange: true
        });
        //this._get_filtered_eod_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, tenderArray, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs, this.state.is_fallback);

    }
    render() { //console.log("sdfsdfsdfsdf", this.state.tableChart);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const tableChartBody = this.state.tableChart.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data['Instance Name']}</td>
                    <td className="align-right">{data['Total Error - Count']}</td>
                    <td className="align-right">{data['Total Error - %']}</td>
                    <td className="align-right">{data['Config Error - Count']}</td>
                    <td className="align-right">{data['Config Error - %']}</td>
                    <td className="align-right">{data['Config Error - Count']}</td>
                    <td className="align-right">{data['Bank Error-%']}</td>

                </tr>
            )
        });

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">POSER Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">

                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>
                                        {this.state.merchant_list_box ===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Merchants</label>
                                                <ReactMultiSelectCheckboxes name="merchants"
                                                    isMulti
                                                    isLoading={this.state.is_merchant_loading}
                                                    value={this.state.merchantValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    options={this.state.merchantList}
                                                    onChange={this.changeMerchant.bind(this,'')}

                                                    placeholderButtonLabel="Select [Merchant]"
                                                />

                                                <div className="clearfix"></div>
                                            </div> : null}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Tender Mode </label>
                                            <ReactMultiSelectCheckboxes name="tender_mode"
                                                                        isMulti
                                                                        value={this.state.tenderModeValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeTenderMode.bind(this)}
                                                                        options={this.state.tenderModeLists}
                                                                        placeholderButtonLabel="Select [Tender Mode]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Txn Type </label>
                                            <ReactMultiSelectCheckboxes name="txn_type"
                                                                        isMulti
                                                                        value={this.state.txnTypeValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeTxnType.bind(this)}
                                                                        options={this.state.txnTypeLists}
                                                                        placeholderButtonLabel="Select [Txn Type ]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Error group </label>
                                            <ReactMultiSelectCheckboxes name="txn_type"
                                                                        isMulti
                                                                        value={this.state.ErrGrpValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeErrGrp.bind(this)}
                                                                        options={this.state.ErrGrpLists}
                                                                        placeholderButtonLabel="Select [Error group ]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {/*{this.state.isChange===true?*/}
                                            {/*    <span className="apply-notification">Please click on Apply button</span>:null*/}
                                            {/*}*/}
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_all_poser_report.bind(this)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_poser_dashboard()}>POSER dashboard</Tab>
                                            <Tab onClick={()=>this.get_filtered_poser_report_row()}>Summary Report</Tab>
                                            <Tab onClick={()=>this.get_poser_details_reports()}>POSER Details</Tab>
                                        </TabList>

                                        <TabPanel>
                                            <div>
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        {/*<div className="dash-header">*/}
                                                        {/*    <p className="dash-title">{chartData.display_name}</p>*/}
                                                        {/*</div>*/}
                                                        <div className="ChartContent">
                                                            <div className="content-tdetails-table table-full-width marginTop0">

                                                                <table id="tableChart" className="table table-striped table-hover">
                                                                    {/*<thead>*/}
                                                                    {/*<tr>*/}
                                                                    {/*    <th>Instance Name</th>*/}
                                                                    {/*    <th>Total Error - Count</th>*/}
                                                                    {/*    <th>Total Error - %</th>*/}
                                                                    {/*    <th>Config Error - Count</th>*/}
                                                                    {/*    <th>Config Error - %</th>*/}
                                                                    {/*    <th>Bank Error - Count</th>*/}
                                                                    {/*    <th>Bank Error - %</th>*/}
                                                                    {/*</tr>*/}
                                                                    {/*</thead>*/}
                                                                    {/*<tbody>*/}
                                                                    {/*{tableChartBody}*/}
                                                                    {/*</tbody>*/}

                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.is_pie===true?
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        {/*<div className="dash-header">*/}
                                                        {/*    <p className="dash-title">{chartData.display_name}</p>*/}
                                                        {/*</div>*/}
                                                        <div className="ChartContent">
                                                            <PoserPieChart data={this.state.pieChartData} x_axis={pie_x_axis} y_axis={pie_y_axis}
                                                                      chartHeight={chartHeight}/>
                                                        </div>
                                                    </div>
                                                </div>:null}
                                                {this.state.is_bar===true?
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="dash-header">
                                                            <p className="dash-title">Error Category</p>
                                                        </div>
                                                        <div className="ChartContent">
                                                            <PoserBarChart data={this.state.barChartData} x_axis={x_axis} y_axis={this.state.y_axis}
                                                                      chartHeight={chartHeight}/>
                                                        </div>
                                                    </div>
                                                </div>:null}
                                                <div className="clearfix"></div>

                                            </div>
                                        </TabPanel>
                                        <TabPanel>
                                           <div>
                                               {this.state.is_exp_button ?
                                                   <div className="">
                                                       <a href="#" className="exportButton" role="button" onClick={this.poser_report_download.bind(this, 'poser_aggregate')}>
                                                           <i className="fa fa-download" aria-hidden="true"></i>
                                                           Export to CSV
                                                       </a>
                                                   </div>:null}
                                               <div className="clearfix"></div>
                                               <BeatLoader
                                                   css={override}
                                                   sizeUnit={"px"}
                                                   size={20}
                                                   color={'#123abc'}
                                                   loading={this.state.loading}
                                               />
                                               {this.state.is_record ?
                                                   <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                       <table id="PoserAggr" className="table table-striped table-hover">

                                                       </table>
                                                   </div>:
                                                   <div className="empty_data" style={{marginTop:'20px'}}> No record Found</div>
                                               }

                                           </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <div>
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.poser_report_download.bind(this, 'poser_details')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <div className="clearfix"></div>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                    <table id="PoserDetailsTable" className="table table-striped table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th width="100px">Error Group</th>
                                                            <th>Instance</th>
                                                            <th width="150px">Merchant</th>
                                                            <th width="150px">Chain</th>
                                                            <th width="150px">Store</th>
                                                            <th>PRIM id</th>
                                                            <th>Transaction Date</th>
                                                            <th>Transaction Time</th>
                                                            <th>Utid</th>
                                                            <th>Btid</th>
                                                            <th>Txn Amount</th>
                                                            <th>Masked Card Number</th>
                                                            <th>BIN</th>
                                                            <th>EMI Bank Code</th>
                                                            <th>Acquiring Bank</th>
                                                            <th>Issuer Bank</th>
                                                            <th>Scheme</th>
                                                            <th>Grade</th>
                                                            <th>Communication Id</th>
                                                            <th>Tender Mode</th>
                                                            <th>Credit/Debit</th>
                                                            <th>Transaction Type</th>
                                                            <th>Approval Code</th>
                                                            <th>RRN No</th>
                                                            <th>UPI Txn ID</th>
                                                            <th>Batch srl</th>
                                                            <th>Merchant Invoice Number</th>
                                                            <th>Processing Code</th>
                                                            <th>Is DCC Transaction</th>
                                                            <th>Is International Card</th>
                                                            <th>Software Version</th>
                                                            <th>Terminal Serial Number</th>
                                                            <th>Addional Info1</th>
                                                            <th>Addional Info2</th>
                                                            <th>CI Inno Response Code</th>
                                                            <th>BI Bank Response Code</th>
                                                            <th>BO Bank Response Code</th>
                                                            <th>CO Inno Response Code</th>
                                                            <th>CO Reason Code</th>
                                                            <th>CO Reason Message</th>
                                                            <th width="150px">UFE Message</th>

                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                    {/*<div className="col-md-2 emi-zone-head">Summary Report</div>*/}
                                    {/*<div className="col-md-3 posDetails">*/}
                                    {/*<Link target="_blank"*/}
                                    {/*    to={{*/}
                                    {/*        pathname: "/admin/poser-details",*/}
                                    {/*        filterProps: {*/}
                                    {/*            start_date: this.state.yestSend,*/}
                                    {/*            end_date: this.state.todSend,*/}
                                    {/*            merchants: this.state.merchantID,*/}
                                    {/*            tender_mode: this.state.tenderModeIDs,*/}
                                    {/*            transaction_type: this.state.txnTypeIDs,*/}

                                    {/*        }*/}
                                    {/*    }} >*/}
                                    {/*    POSER Details*/}
                                    {/*</Link>*/}
                                    {/*</div>*/}
                                    <div className="clearfix"></div>


                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(PoserReport)